@if (!hideText()) {
  <footer class="footer">
    <div class="container">
      <div class="container inner">
        <div class="providers-container">
          <div class="footer__title">{{ 't.payments-methods' | translate }}</div>
          <ng-container *ngTemplateOutlet="paymentMethods"></ng-container>
        </div>
        <div class="pt-20">
          <ng-content></ng-content>
        </div>
        <ng-container>
          <ng-container *ngTemplateOutlet="social"></ng-container>
        </ng-container>
        <div class="providers center align-center">
          <ng-container *ngTemplateOutlet="license"></ng-container>
        </div>
        </div>
      </div>
    </footer>
  }


<ng-template #license>
  @if (novatrix.novatrixSealId() && novatrix.novatrixDlagAttrId()) {
    <div [id]="novatrix.novatrixDlagAttrId()" [attr.data-dlag-seal-id]="novatrix.novatrixSealId()" data-dlag-image-size="128" data-dlag-image-type="basic-light-small"></div>
  }
  @if (license$ | async; as license) {
    @if (license.Url) {
      <a class="providers__item --curacao" target="_blank" rel="nonoopener" [href]="license?.Url">
        <img loading="lazy" [src]="license?.Img" alt="SpinSamurai casino - license">
      </a>
    } @else {
      <div class="providers__item --curacao">
        <img loading="lazy" [src]="license?.Img" alt="SpinSamurai casino - license">
      </div>
    }
  }
  <img loading="lazy" class="providers__item" [src]="'/assets/svg/security-logos/be-gamble-aware.svg'" alt="be-gamble-aware">
  <img loading="lazy" class="providers__item" [src]="'/assets/svg/security-logos/comodossl.svg'" alt="comodossl">
  <img loading="lazy" class="providers__item ask" src="/assets/svg/askgamblers.svg" alt="askgamblers">
</ng-template>
<ng-template #social>
  @if (social$ | async; as social) {
    <div class="social__actions">
      @if (social[0]?.DiscordBtnLink; as url) {
        <a [href]="url" target="_blank">
          <img loading="lazy" [src]="'/assets/img/social-redesign/discord.png'" alt="discord" class="discord">
        </a>
      }
      @if (social[0]?.FacebookBtnLink; as url) {
        <a [href]="url" target="_blank">
          <img loading="lazy" [src]="'/assets/img/social-redesign/facebook.png'" alt="facebook" class="facebook" />
        </a>
      }
      @if (social[0]?.YouTubeBtnLink; as url) {
        <a [href]="url" target="_blank">
          <img loading="lazy" [src]="'/assets/img/social-redesign/youtube.png'" alt="youtube" class="youtube" />
        </a>
      }
      @if (social[0]?.WhatsAppBtnLink; as url) {
        <a [href]="url" target="_blank">
          <img loading="lazy" [src]="'/assets/img/social-redesign/whatsapp.png'" alt="whatsapp" class="whatsapp" />
        </a>
      }
      @if (social[0]?.TelegramBtnLink; as url) {
        <a [href]="url" target="_blank">
          <img loading="lazy" [src]="'/assets/img/social-redesign/telegram.png'" alt="telegram" class="telegram">
        </a>
      }
      @if (social[0]?.TwitterBtnLink; as url) {
        <a [href]="url" target="_blank">
          <img loading="lazy" [src]="'/assets/img/social-redesign/twitter.png'" alt="twitter" class="twitter">
        </a>
      }
      @if (social[0]?.InstagramBtnLink; as url) {
        <a [href]="url" target="_blank">
          <img loading="lazy"  [src]="'/assets/img/social-redesign/instagram.png'" alt="instagram" class="instagram">
        </a>
      }
    </div>
  }
  @if (copyright$ | async; as copyright) {
    <div class="copyright"
         [innerHTML]="copyright[0]?.Content | safe: 'html'"></div>
  }
</ng-template>
<ng-template #paymentMethods>
  <app-accordion-button [isFooter]="true">
    @if (banking.paymentList$ | async; as paymentList) {
      <div class="providers center clickable">
        <div class="payments">
          @for (payment of paymentList; track $index) {
            @if (!payment?.IsCrypto) {
              <img
                class="providers__item {{payment?.slug}}"
                DeleteNotFound
                routerLink="/profile/deposit"
                (click)="onProviderClick(payment)"
                [src]="payment?.footerImg"
                loading="lazy"
                height="25" width="60"
                [alt]="payment?.slug"
              >
            }
          }
        </div>
      </div>
      <div class="providers center clickable">
        <div class="payments">
          @for (payment of paymentList; track $index) {
            @if (payment?.IsCrypto) {
              <img
                DeleteNotFound
                class="providers__item"
                routerLink="/profile/deposit"
                (click)="onProviderClick(payment)"
                [src]="payment?.footerImg"
                loading="lazy"
                [alt]="payment?.slug"
                height="25" width="60"
              >
            }
          }
        </div>
      </div>
    }
  </app-accordion-button>
  <div class="footer__title">{{ 't.providers' | translate }}</div>
  <app-accordion-button [isFooter]="true">
    @if (providerList$ | async; as providerList) {
      <div class="providers center clickable">
        @for (provider of providerList; track $index) {
          <a class="providers__item"
             (click)="onProviderClick(provider)"
             [href]="'/games/' + provider.alias"
             DeleteNotFound
          >
            @if (!provider?.customImg) {
              <img
                [ngClass] = "{'provider-light':provider?.alias === 'gameburgerstudios' || provider?.alias ===
                        'reflexgaming' || provider?.alias === 'goldcoinstudios'}"
                height="25" width="60" loading="lazy"
                [src] = "provider.imgAlias" [alt]="provider?.alias"
              >
            }
            @if (provider?.customImg) {
              <img
                loading="lazy"
                class="{{provider.alias}}"
                [src] = "provider?.customImg"
                [alt]="provider?.alias"
              >
            }
          </a>
        }
      </div>
    }
  </app-accordion-button>
  @if (partnerList$ | async; as partnerList) {
    <div class="providers center clickable">
      @for (partner of partnerList; track $index) {
        @if (partner?.Logo) {
          <a target="_blank" class="providers__item" [href]="partner?.Link">
            <img [src]="partner?.Logo" [alt]="partner?.Text" loading="lazy" height="25" width="60">
          </a>
        }
      }
    </div>
  }
</ng-template>
